export default "__VITE_ASSET__DtoIPUmD__"